/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaSelectOneGhostLabel/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function TysiaSelectOneGhostLabel({
  children,
  viewPath = "/DesignSystem/TysiaSelectOneGhost/TysiaSelectOneGhostLabel",
  showTooltip,
  hoverTriggerDelay,
  hoverLeaveDelay,
  size = "small",
  marginRight = 0,
  marginTop = 0,
  onFocus,
  isShowingOptions,
  onBlur,
  weight = "medium",
  placeholder,
  maxWidth,
  color,
  hovered,
  disabled,
  optionValue,
  required
  
}) {
let dtFontsizesMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'fontSizes.mm'
        })
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let dtTypographyFontsizeM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.m'
        })
let dtTypographyFontsizeMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.ms'
        })
let dtTypographyFontsizeMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontSize.mm'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let colorOrdtColorsNeutral600 = color ?? dtColorsNeutral600
let colorOrdtColorsNeutral6001 = color ?? dtColorsNeutral600
let dtColorsRed600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.red.600'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnHover={showTooltip}
 showOnClick={false}
 showOnRightClick={false}
 hoverTriggerDelay={hoverTriggerDelay}
 hoverLeaveDelay={hoverLeaveDelay}
>
{childProps => (
<React.Fragment>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 size={size}
 type="ghost"
 cursor="pointer"
 marginRight={marginRight}
 marginTop={marginTop}
 paddingLeft={0}
 paddingRight={0}
 display="block"
 onClick={isShowingOptions ? onBlur : onFocus}
>
{childProps => (
<React.Fragment>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 weight={weight}
 text={optionValue ? optionValue : placeholder}
 whiteSpace="nowrap"
 textOverflow="ellipsis"
 display="inline-block"
 maxWidth={maxWidth}
 overflowX="hidden"
 fontSize={size === "small" ? dtTypographyFontsizeM : size === "tiny" ? dtTypographyFontsizeMs : size === "normal" ? dtTypographyFontsizeMm : dtFontsizesMm}
 marginLeft={0}
 marginRight={0}
 color={hovered && !disabled ? dtColorsNeutral700 : disabled ? dtColorsNeutral400 : optionValue ? dtColorsNeutral900 : colorOrdtColorsNeutral6001}
/>
<fromFlow.When is={required}>
<TysiaText
{...childProps}
  viewPath={`${viewPath}/TysiaText`}
 text="*"
 marginLeft="2px"
 color={dtColorsRed600}
 fontSize={size === "small" ? dtTypographyFontsizeM : size === "tiny" ? dtTypographyFontsizeMs : size === "normal" ? dtTypographyFontsizeMm : dtTypographyFontsizeMm}
/>
</fromFlow.When>
</React.Fragment>
)}
</TysiaButton>
)}
</PopoverTrigger>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 maxWidth={500}
 height="auto"
 top={-70}
 className="new-shadow"
 whiteSpace="normal"
 text={placeholder}
 className="new-shadow"
/>
)}
</PopoverContentHover>
</React.Fragment>
)}
</Popover>
{children}
</React.Fragment>)
}